import { IAutoMapper } from "../../../../../../core/automapper/interfaces";
import { StringHelper } from "../../../../../../utilities/contracts/string-helper";

const OVERREADER2_ROLE_NAME = "Overreader2";

/** Manager decision stored on the feedback item: Coding = coder was right, Qa = overreader was right. */
export enum FeedbackChallengeDecision {
  APPROVED = "Coding",
  DENIED = "Qa",
  MIXED = "Mixed",
}

export const mapFeedbackChallengeQueryItem = (automapper: IAutoMapper): void => {
  automapper.createMap("default", "FeedbackChallengeQueryItem")
    .forMember("chaseId", o => o.chaseId)
    .forMember("projectId", o => o.projectId)
    .forMember("projectName", o => o.projectName)
    .forMember("measureCode", o => o.measureCode)
    .forMember("codingUserId", o => o.codingUserId)
    .forMember("codingUserName", o => o.codingUserName)
    .forMember("codingDate", o => o.codingDate)
    .forMember("qaUserId", o => o.qaUserId)
    .forMember("qaUserName", o => o.qaUserName)
    .forMember("qaRoleName", o => o.qaRoleName)
    .forMember("qaDate", o => o.qaDate)
    .forMember("overreadLevel", o => o.qaRoleName === OVERREADER2_ROLE_NAME ? "OR II" : "OR I")
    .forMember("managerUserId", o => o.managerUserId)
    .forMember("managerUserName", o => o.managerUserName)
    .forMember("assignedToUserId", o => o.assignedToUserId)
    .forMember("assignedToUserName", o => o.assignedToUserName)
    .forMember("errorCount", o => o.errorCount)
    .forMember("chaseOverreadFeedbackStatus", o => o.chaseOverreadFeedbackStatus)
    .forMember("correctDataset", o => o.correctDataset)
    .forMember("codingReviewMode", o => o.codingReviewMode)
    .forMember("recordCount", o => o.recordCount);
};

export class FeedbackChallengeQueryItem {
  chaseId: number;
  projectId: number;
  projectName: string;
  measureCode: string;
  codingUserId: number;
  codingUserName: string;
  codingDate: Date;
  qaUserId: number;
  qaUserName: string;
  qaRoleName: string;
  qaDate: Date;
  overreadLevel: string;
  managerUserId: number;
  managerUserName: string;
  assignedToUserId: number;
  assignedToUserName: string;
  errorCount: number;
  chaseOverreadFeedbackStatus: string;
  correctDataset: string;
  codingReviewMode: string;
  recordCount: number;

  constructor(options: Partial<FeedbackChallengeQueryItem>) {
    this.chaseId = options.chaseId;
    this.projectId = options.projectId;
    this.projectName = StringHelper.clean(options.projectName);
    this.measureCode = StringHelper.clean(options.measureCode);
    this.codingUserId = options.codingUserId;
    this.codingUserName = StringHelper.clean(options.codingUserName);
    this.codingDate = options.codingDate;
    this.qaUserId = options.qaUserId;
    this.qaUserName = StringHelper.clean(options.qaUserName);
    this.qaRoleName = StringHelper.clean(options.qaRoleName);
    this.qaDate = options.qaDate;
    this.overreadLevel = StringHelper.clean(options.overreadLevel);
    this.managerUserId = options.managerUserId;
    this.managerUserName = StringHelper.clean(options.managerUserName);
    this.assignedToUserId = options.assignedToUserId;
    this.assignedToUserName = StringHelper.clean(options.assignedToUserName);
    this.errorCount = options.errorCount;
    this.chaseOverreadFeedbackStatus = StringHelper.clean(options.chaseOverreadFeedbackStatus);
    this.correctDataset = StringHelper.clean(options.correctDataset);
    this.codingReviewMode = options.codingReviewMode;
    this.recordCount = options.recordCount;
  }

  /** Outcome shown on the Complete tab; empty while the challenge awaits a decision. */
  get decisionOutcome(): string {
    switch (this.correctDataset) {
      case FeedbackChallengeDecision.APPROVED:
        return "Challenge Approved";
      case FeedbackChallengeDecision.DENIED:
        return "Challenge Denied";
      case FeedbackChallengeDecision.MIXED:
        return "Partially Approved";
      default:
        return "";
    }
  }
}
